// extracted by mini-css-extract-plugin
module.exports = {"jumpToWxMini_content":"jumpToWxMini_jumpToWxMini_content__B3ori","img_wrap":"jumpToWxMini_img_wrap__3KrD2","img_text":"jumpToWxMini_img_text__1GeAj"};